/**
 * Parse stats.json file and format numbers for display
 */

const formatNumber = num => {
  if (!num || isNaN(num)) {
    return '0';
  }
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M+`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K+`;
  }
  return `${num}+`;
};

export const getHomeCarouselStats = async () => {
  const response = await fetch('/stats.json');
  const data = await response.json();

  // Get the current version stats
  const currentVersion = data.current;
  const stats = data[currentVersion]?.statistics;

  if (!stats) {
    throw new Error('Stats not found in current version');
  }

  return [
    `${formatNumber(stats.gda_gene || stats.gene)} disease genes`,
    `${formatNumber(stats.evidence)} evidences`,
    `${formatNumber(stats.gda_disease || stats.disease)} diseases & traits`,
    `${formatNumber(stats.vda_variant || stats.variant)} disease variants`,
  ];
};
